import { BusinessObjectBase } from './base';
import type { Role } from './role';
import type { Token } from './token';
import type { User } from './user';

export interface MyUserTaskData {
  readonly id: string;
  readonly userTaskId: string;
  readonly referenceNumber?: number;
  readonly name?: string;
  readonly status?: string;
  readonly data?: any;
  readonly completedAt?: Date;
  readonly candidateUserId?: number;
  readonly createdAt?: Date;
  readonly updatedAt?: Date;
  readonly roleId: number;
  readonly role?: Role;
  readonly userId: number;
  readonly user?: User;
  readonly tokenId: number;
  readonly token?: Token;
}

export interface MyUserTask extends Readonly<MyUserTaskData> {}
export class MyUserTask extends BusinessObjectBase {
  static readonly entityName = 'MyUserTask' as const;
  static readonly plural = 'my-user-tasks';

  // --- Static CRUD methods ---

  static async find(filter?: any): Promise<MyUserTask[]> {
    const url = `${this.baseUrl}/${this.plural}`;
    const params: Record<string, string> = {};
    if (filter) params['filter'] = JSON.stringify(filter);
    const results = await this.get<any[]>(url, params);
    return results.map((data) => new MyUserTask(data));
  }

  static async findOne(filter?: any): Promise<MyUserTask | null> {
    const url = `${this.baseUrl}/${this.plural}/find-one`;
    const params: Record<string, string> = {};
    if (filter) params['filter'] = JSON.stringify(filter);
    const data = await this.get<any>(url, params);
    return data ? new MyUserTask(data) : null;
  }

  static async findById(id: string, filter?: any): Promise<MyUserTask> {
    const url = `${this.baseUrl}/${this.plural}/${id}`;
    const params: Record<string, string> = {};
    if (filter) params['filter'] = JSON.stringify(filter);
    const data = await this.get<any>(url, params);
    return new MyUserTask(data);
  }

  static async create(data: Omit<MyUserTaskData, 'id'>): Promise<MyUserTask> {
    const url = `${this.baseUrl}/${this.plural}`;
    const result = await this.post<any>(url, data);
    return new MyUserTask(result);
  }

  static async updateById(
    id: string,
    data: Partial<MyUserTaskData>,
  ): Promise<MyUserTask> {
    const url = `${this.baseUrl}/${this.plural}/${id}`;
    const result = await this.patch<any>(url, data);
    return new MyUserTask(result);
  }

  static async deleteById(id: string): Promise<boolean> {
    const url = `${this.baseUrl}/${this.plural}/${id}`;
    try {
      await this.del<void>(url);
      return true;
    } catch {
      return false;
    }
  }
}
